var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 67.548,
    viewBox: "0 0 25 67.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.e{fill:none;}.a,.c{stroke:#fff;}.b{fill:#fff;}.c{stroke-linecap:round;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-948 -909)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 -94)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(930 1003)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 25,
    height: 41,
    rx: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 40,
    rx: 12
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 8,
    rx: 1.5,
    transform: "translate(941 1013)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(953 961.5)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 8,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 8,
    y2: 7,
    transform: "translate(8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(953 968.842)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 8,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 8,
    y2: 7,
    transform: "translate(8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseIco);
export default __webpack_public_path__ + "static/media/mouse_ico.8f8f38d5e4f05867dceb00788d596398.svg";
export { ForwardRef as ReactComponent };